module.exports = __webpack_public_path__ + "static/media/imagenDarkBrown.1c153c68.png";